/**
 * ═══════════════════════════════════════
 * Gallery.js — Lightbox para galerías de destinos
 * ═══════════════════════════════════════
 *
 * Lightbox nativo en Vanilla JS.
 * Se activa en cualquier elemento con [data-lightbox].
 */

/**
 * Estado del lightbox
 */
let lightboxElement = null;
let imagenActual    = null;
let indiceActual    = 0;
let imagenes        = [];

/**
 * Crea el DOM del lightbox (una sola vez)
 */
function crearLightbox() {
  if ( lightboxElement ) return;

  lightboxElement = document.createElement('div');
  lightboxElement.className = 'lightbox';
  lightboxElement.id = 'turismo-lightbox';
  lightboxElement.setAttribute('role', 'dialog');
  lightboxElement.setAttribute('aria-modal', 'true');
  lightboxElement.setAttribute('aria-label', 'Galería de imágenes');

  lightboxElement.innerHTML = `
    <button class="lightbox__close" aria-label="Cerrar galería">&times;</button>
    <button class="absolute left-4 top-1/2 -translate-y-1/2 text-white text-4xl hover:text-primary transition-colors z-10" aria-label="Imagen anterior" id="lb-prev">&#8249;</button>
    <img class="lightbox__image" src="" alt="" />
    <button class="absolute right-4 top-1/2 -translate-y-1/2 text-white text-4xl hover:text-primary transition-colors z-10" aria-label="Imagen siguiente" id="lb-next">&#8250;</button>
    <div class="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-sm" id="lb-counter"></div>
  `;

  document.body.appendChild(lightboxElement);

  /* Eventos de cierre */
  lightboxElement.querySelector('.lightbox__close').addEventListener('click', cerrarLightbox);
  lightboxElement.addEventListener('click', (e) => {
    if ( e.target === lightboxElement ) cerrarLightbox();
  });

  /* Navegación */
  document.getElementById('lb-prev').addEventListener('click', (e) => {
    e.stopPropagation();
    navegarLightbox(-1);
  });
  document.getElementById('lb-next').addEventListener('click', (e) => {
    e.stopPropagation();
    navegarLightbox(1);
  });

  /* Teclado */
  document.addEventListener('keydown', (e) => {
    if ( ! lightboxElement.classList.contains('is-active') ) return;
    if ( e.key === 'Escape' ) cerrarLightbox();
    if ( e.key === 'ArrowLeft' ) navegarLightbox(-1);
    if ( e.key === 'ArrowRight' ) navegarLightbox(1);
  });
}

/**
 * Abre el lightbox con una imagen específica
 *
 * @param {number} indice Índice de la imagen en el array
 */
function abrirLightbox(indice) {
  crearLightbox();
  indiceActual  = indice;
  imagenActual  = lightboxElement.querySelector('.lightbox__image');

  actualizarImagen();
  lightboxElement.classList.add('is-active');
  document.body.style.overflow = 'hidden';
}

/**
 * Cierra el lightbox
 */
function cerrarLightbox() {
  if ( ! lightboxElement ) return;
  lightboxElement.classList.remove('is-active');
  document.body.style.overflow = '';
}

/**
 * Navega a la imagen anterior o siguiente
 *
 * @param {number} direccion -1 para anterior, 1 para siguiente
 */
function navegarLightbox(direccion) {
  indiceActual = ( indiceActual + direccion + imagenes.length ) % imagenes.length;
  actualizarImagen();
}

/**
 * Actualiza la imagen mostrada en el lightbox
 */
function actualizarImagen() {
  if ( ! imagenActual || ! imagenes[indiceActual] ) return;

  const img  = imagenes[indiceActual];
  imagenActual.src = img.src;
  imagenActual.alt = img.alt || 'Imagen de galería';

  const counter = document.getElementById('lb-counter');
  if ( counter ) {
    counter.textContent = `${indiceActual + 1} / ${imagenes.length}`;
  }
}

/**
 * Inicializa la galería buscando elementos [data-lightbox]
 * Se llama desde main.js al cargar el DOM.
 */
export function inicializarGaleria() {
  const galerias = document.querySelectorAll('[data-lightbox-gallery]');

  galerias.forEach((galeria) => {
    const items = galeria.querySelectorAll('[data-lightbox]');

    items.forEach((item, indice) => {
      item.style.cursor = 'pointer';
      item.addEventListener('click', (e) => {
        e.preventDefault();

        /* Recopilar imágenes de esta galería */
        imagenes = Array.from(items).map((el) => ({
          src: el.dataset.lightbox || el.querySelector('img')?.src || el.src,
          alt: el.dataset.lightboxAlt || el.querySelector('img')?.alt || '',
        }));

        abrirLightbox(indice);
      });
    });
  });

  /* También soportar imágenes sueltas con [data-lightbox] */
  const imagenesSueltas = document.querySelectorAll('[data-lightbox]:not([data-lightbox-gallery] [data-lightbox])');
  imagenesSueltas.forEach((img) => {
    img.style.cursor = 'pointer';
    img.addEventListener('click', (e) => {
      e.preventDefault();
      imagenes = [{
        src: img.dataset.lightbox || img.src,
        alt: img.alt || '',
      }];
      abrirLightbox(0);
    });
  });
}
